export enum BlockActionEnum {
  Create = 'new',
  Edit = 'edit',
}
